import { render } from "./Kalendar.vue?vue&type=template&id=f88f2660&scoped=true"
import script from "./Kalendar.vue?vue&type=script&lang=js"
export * from "./Kalendar.vue?vue&type=script&lang=js"

import "./Kalendar.vue?vue&type=style&index=0&id=f88f2660&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f88f2660"

export default script